/**
 * SiteBreakdownCard - Displays risks by site location
 * 
 * Features:
 * - Handles empty state gracefully
 * - Keyed by site_id for institutional stability (renames don't break history)
 * - Right-aligned tabular counts
 */
import React from 'react';

export const SiteBreakdownCard = ({ bySite, onViewAll }) => {
  // bySite format: { "site-1": { name: "Main Office", count: 3 }, ... }
  const siteEntries = Object.entries(bySite ?? {}).map(([siteId, data]) => ({
    id: siteId,
    name: data?.name || siteId,
    count: data?.count ?? 0
  })).sort((a, b) => b.count - a.count); // Sort by count descending
  
  const hasSites = siteEntries.length > 0;
  
  return (
    <div className="dashboard-card" data-testid="site-breakdown-card">
      <div className="breakdown-header">
        <h3>By Site</h3>
        {onViewAll && (
          <button className="view-all-link" onClick={onViewAll} data-testid="site-view-all">
            View All →
          </button>
        )}
      </div>
      <div className="site-breakdown">
        {hasSites ? (
          siteEntries.map(({ id, name, count }) => (
            <div key={id} className="breakdown-row" data-testid={`site-row-${id}`}>
              <span className="breakdown-label">{name}</span>
              <span className="breakdown-count">{count}</span>
            </div>
          ))
        ) : (
          <p className="no-data">No active reports by site</p>
        )}
      </div>
    </div>
  );
};

export default SiteBreakdownCard;
